export const BOARD_VIEW_MODS = {
  LARGE: 'large',
  MEDIUM: 'medium',
  SMALL: 'small',
};

export const BOARD_VIEW_WINDOW_SIZES = {
  LARGE: 1576,
  MEDIUM: 1076,
};
